import { take, put } from "redux-saga/effects";
import { ACTIVATE_MASK_ITEM, SET_ACTIVE_MENU_PATH, SET_MENU_CACHE } from "../../actions/configurationActions";
import { CONTENT_LOADING, OPEN_SIDE_MENU } from "../../actions/sideMenuActions";

function* toggleSideMenu(isOpen: boolean) {
    yield put({
        type: OPEN_SIDE_MENU,
        sideMenuOpen: isOpen,
    });
}

export function* sideMenuActivateItemSaga(): any {
    while (yield take([ACTIVATE_MASK_ITEM, SET_ACTIVE_MENU_PATH])) {
        yield toggleSideMenu(true);
    }
}

export function* sideMenuSetItemsSaga(): any {
    while (yield take(SET_MENU_CACHE)) {
        yield put({
            type: CONTENT_LOADING,
            contentLoading: false,
        });
    }
}
